import React, { useEffect } from "react";
import { IconButton, Typography, Tooltip, Checkbox } from "@mui/material";
import { ArrowBack, Clear } from "@mui/icons-material";
import { useState } from "react";
import { PopoverListButtons } from "../../../Utils/styledComps";
import "../SBComponents/cssFile/viewMenu.css";

// import { container } from "webpack";
const CustomViewPopoverContent = ({
  selectedFeature,
  view,
  mainCanvas,
  handleBackButtonClick,
  handlePopoverClose,
  horizonalGuidesRef,
  verticalGuidesRef,
  showGuides,
  showRuler,
  onAddCanvas,
  activeCanvasIndex,
  switchCanvas,
  canvasArray,
  setShowGuides,
  containerDim,
  setContainerDim,
  selectedOption,
  handleSelectChange,
}) => {
  const [gridVisible, setGridVisible] = useState(true);
  // const [selectedOption, setSelectedOption] = useState(activeCanvasIndex);
  const [clipboard, setClipboard] = useState(null);
  const [cloneIndex, setCloneIndex] = useState(0);
  const [cloneMap, setCloneMap] = useState(new Map()); // Track clones per object
  const handleCopy = () => {
    if (mainCanvas.getActiveObject()) {
      mainCanvas.getActiveObject().clone(function (cloned) {
        setClipboard(cloned);
      });
    }
  };

  // Function to paste the copied object
  const handlePaste = () => {
    if (clipboard) {
      clipboard.clone(function (clonedObj) {
        mainCanvas.discardActiveObject();
        // clonedObj.set({
        //   left: clonedObj.left + 100,
        //   top: clonedObj.top + 100,
        //   evented: true,
        // });
        clonedObj.set({
          top: clonedObj.top + clonedObj.height + 10,
          evented: true,
        });
        mainCanvas.add(clonedObj);
        mainCanvas.setActiveObject(clonedObj);
        mainCanvas.requestRenderAll();
      });
    }
  };

  // Function to clone the object
  const handleClone = () => {
    const activeObject = mainCanvas.getActiveObject();
    if (!activeObject) return;

    // Clone the active object
    activeObject.clone((cloned) => {
      // Set parent ID if needed
      if (!activeObject.parentId) {
        activeObject.set({ parentId: `parent-${cloneIndex}` });
      }

      // Position the clone relative to ORIGINAL object
      cloned.set({
        left: activeObject.left,
        top: activeObject.top,
        cloneId: `${activeObject.parentId}-clone-${cloneIndex}`,
        evented: true,
      });

      // console.log("cloneObject", clonedObj);
      console.log("activeObjectObject", activeObject);

      // Add to canvas and update state
      mainCanvas.add(cloned);
      setClipboard(cloned); // Store for future cloning
      setCloneIndex((prev) => prev + 1);
      mainCanvas.requestRenderAll();
    });
  };
  // const handleClone = () => {
  //   if (mainCanvas.getActiveObject()) {
  //     mainCanvas.getActiveObject().clone(function (cloned) {
  //       setClipboard(cloned);
  //     });
  //   }

  //   if (clipboard) {
  //     clipboard.clone(function (clonedObj) {
  //       const activeObject = mainCanvas.getActiveObject();
  //       if (!activeObject.parentId) {
  //         activeObject.set({ parentId: `parent-${cloneIndex}` });
  //       }

  //       console.log("activeObject: ", activeObject);
  //       clonedObj.set({
  //         top: clonedObj.top + clonedObj.height + 10,
  //         cloneId: `${activeObject.parentId}-clone-${cloneIndex}`,
  //         evented: true,
  //       });
  //       console.log("cloneObject", clonedObj);
  //       console.log("activeObjectObject", activeObject);

  //       setCloneIndex(cloneIndex + 1);
  //       mainCanvas.add(clonedObj);
  //       mainCanvas.requestRenderAll();
  //     });
  //   }
  // };

  useEffect(() => {
    if (mainCanvas) {
      console.log("mainCanvasheight", mainCanvas.height);
      console.log("mainCanvaswidth", mainCanvas.width);
      console.log("on_Add_Canvas", onAddCanvas);
      console.log("canvasArray", canvasArray);
      console.log("activeCanvasIndex", activeCanvasIndex);
      console.log("switchCanvas", switchCanvas);
    }
    console.log("mainCanvas is show: ", mainCanvas);
    console.log("horizonalGuidesRef is show: ", horizonalGuidesRef);
    console.log("verticalGuidesRef is show: ", verticalGuidesRef);
  }, [mainCanvas, horizonalGuidesRef, verticalGuidesRef]);

  const renderPopoverContent = () => {
    if (selectedFeature) {
      const feature = view.find((item) => item.label === selectedFeature);
      // Function to handle actions on the mainCanvas for grid

      return (
        <div style={{ height: "500px", width: "300px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginRight: "10px",
              marginLeft: "10px",
            }}
          >
            <IconButton
              edge="start"
              sx={{ borderRadius: 0 }}
              onClick={handleBackButtonClick}
            >
              <ArrowBack />
            </IconButton>
            <Typography
              sx={{ m: 0, fontSize: 18, color: "#f0f2f7", fontWeight: 800 }}
            >
              {selectedFeature}
            </Typography>
            <IconButton
              edge="end"
              sx={{ borderRadius: 0 }}
              onClick={handlePopoverClose}
            >
              <Clear />
            </IconButton>
          </div>
          <div
            style={{
              display: "flex",
              columnGap: 8,
              margin: "10px",
              flexWrap: "wrap",
            }}
          >
            {feature?.children?.map((obj, index) => (
              <Tooltip key={index} title={obj.label}>
                <PopoverListButtons onClick={obj.onClick}>
                  {obj.icon}
                </PopoverListButtons>
              </Tooltip>
            ))}
          </div>
        </div>
      );
    }

    // for grid function
    const handleToggleGrid = () => {
      let visible = !gridVisible;
      setGridVisible(visible);
      console.log("grid visible");

      if (mainCanvas) {
        const activeGrids = mainCanvas._objects;
        console.log("activeGrids", activeGrids);

        activeGrids.forEach((obj) => {
          if (obj?.name === "gridLine") {
            obj.set({ visible: visible });
            console.log("iterate for grid", obj?.name);
          }
        });
        mainCanvas.renderAll();
      }
    };
    // for guides function
    const handleToggleGuides = () => {
      let visible = !showGuides;
      console.log("Guides visibility:", visible);
      setShowGuides(visible);
    };

    const handleFullPage = () => {
      console.log("containerDim height:", containerDim.height);
      console.log("containerDim width:", containerDim.width);

      const canvasHeight = mainCanvas.getHeight() / mainCanvas.getZoom();
      const canvasWidth = mainCanvas.getWidth() / mainCanvas.getZoom();
      console.log("canvas Width and height", canvasWidth, canvasHeight);

      if (containerDim && canvasHeight && canvasWidth) {
        const scaleFactorHeight = containerDim.height / canvasHeight;
        const scaleFactorWidth = containerDim.width / canvasWidth;

        const scaleFactor = Math.min(scaleFactorHeight, scaleFactorWidth);
        console.log(
          "scaleFactor",
          scaleFactor,
          canvasWidth,
          canvasHeight,
          containerDim
        );

        mainCanvas.setZoom(scaleFactor);

        mainCanvas.renderAll();

        console.log(
          "New canvas dimensions (zoom applied):",
          mainCanvas.getWidth() / mainCanvas.getZoom(),
          mainCanvas.getHeight() / mainCanvas.getZoom()
        );

        if (scaleFactor < 1) {
          console.log("Scaling down canvas to fit within the container.");

          mainCanvas.setZoom(scaleFactor);

          mainCanvas.setHeight(
            (canvasHeight - containerDim.paddingTop - containerDim.marginTop) *
              scaleFactor
          );
          mainCanvas.setWidth(canvasWidth * scaleFactor);

          console.log(
            "Canvas resized to:",
            canvasWidth * scaleFactor,
            canvasHeight * scaleFactor
          );
        } else if (scaleFactor > 1) {
          console.log("Canvas is smaller than container. No need to scale up.");
          mainCanvas.setZoom(1);
        } else {
          console.log("Canvas dimensions are equal to the container.");
          mainCanvas.setZoom(1);
        }

        mainCanvas.renderAll();
      }
    };

    // clickAddPages

    // const handleSelectChange = (event) => {
    //   const selectedValue = event.target.value;
    //   setSelectedOption(selectedValue);
    //   switchCanvas(parseInt(selectedValue));
    //   console.log("Selected Option:", selectedValue);
    // };

    const clickAddPages = () => {
      if (onAddCanvas) {
        onAddCanvas();
        console.log("page is added");
      }
    };

    return (
      <div style={{ height: "500px", width: "300px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "10px",
          }}
        >
          <Typography
            sx={{
              m: 0,
              pl: 2,
              fontSize: 18,
              color: "#f0f2f7",
              fontWeight: 800,
            }}
          >
            View
          </Typography>
          <IconButton
            edge="end"
            sx={{ borderRadius: 0 }}
            onClick={handlePopoverClose}
          >
            <Clear />
          </IconButton>
        </div>

        <div className="Page_number">
          <div
            className=""
            style={{
              display: "flex",
              justifyContent: "flexstart",
              flexDirection: "column",
              alignItems: "space-between",
              gap: "20px",
            }}
          >
            <div className="page_align">
              <label>Pages</label>
              <select onChange={handleSelectChange} value={selectedOption}>
                {canvasArray.map((canvas, index) => (
                  <option key={index} value={index}>
                    {`Page ${index + 1}`}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "60px",
                alignItems: "center",
              }}
            >
              <label style={{ color: "#fff", fontWeight: "bold" }}>Total</label>
              <span style={{ color: "#fff" }}>{canvasArray.length} pages</span>
            </div>
          </div>

          {/* button */}
          <div>
            <button
              onClick={clickAddPages}
              style={{
                fontSize: "25px",
                borderRadius: "4px",
                cursor: "pointer",
                border: "none",
                padding: "21px 14px",
                "&:hover": {
                  backgroundColor: "#efefef",
                },
              }}
            >
              +
            </button>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "20px",
          }}
        >
          <button
            onClick={handleCopy}
            style={{
              cursor: "pointer",
              padding: "5px 10px",
              fontWeight: "bold",
              borderRadius: "4px",
              border: "none",
              outline: "none",
            }}
          >
            Copy
          </button>
          <button
            onClick={handlePaste}
            style={{
              cursor: "pointer",
              padding: "5px 10px",
              fontWeight: "bold",
              borderRadius: "4px",
              border: "none",
              outline: "none",
            }}
          >
            Paste
          </button>
          <button
            onClick={handleClone}
            style={{
              cursor: "pointer",
              padding: "5px 10px",
              fontWeight: "bold",
              borderRadius: "4px",
              border: "none",
              outline: "none",
            }}
          >
            Clone
          </button>
        </div>

        <div
          style={{
            display: "flex",
            columnGap: 8,
            margin: "10px",
            flexWrap: "wrap",
          }}
        >
          {view.map((obj, index) => {
            if (
              obj.label === "Grid" ||
              obj.label === "Guides" ||
              obj.label === "Ruler"
            ) {
              const checked =
                obj.label === "Grid"
                  ? gridVisible
                  : obj.label === "Guides"
                  ? showGuides
                  : showRuler;

              const handleToggle =
                obj.label === "Grid"
                  ? handleToggleGrid
                  : obj.label === "Guides"
                  ? handleToggleGuides
                  : obj.label === "Ruler" && obj.onClick;

              return (
                // <Tooltip key={index} title={obj.label}>
                //   <div
                //     style={{
                //       display: "flex",
                //       alignItems: "center",
                //     }}
                //   >
                //     <Checkbox
                //       checked={checked}
                //       onChange={handleToggle}
                //       icon={obj.icon}
                //       checkedIcon={obj.icon}
                //     />
                //   </div>
                // </Tooltip>
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "52px",
                    margin: "5px",
                    cursor: "pointer",
                    color: "#f0f2f7",
                  }}
                  onClick={handleToggle}
                >
                  <Checkbox
                    checked={checked}
                    icon={obj.icon}
                    checkedIcon={obj.icon}
                    sx={{ p: 2 }}
                  />
                  <Typography
                    variant="caption"
                    sx={{ mt: 0.5, textAlign: "center", fontSize: "11px" }}
                  >
                    {obj.label}
                  </Typography>
                </div>
              );
            }

            // For other items, just show the button without a checkbox
            return (
              // <Tooltip key={index} title={obj.label}>
              //   <PopoverListButtons

              //   >
              //     {obj.icon}
              //   </PopoverListButtons>
              // </Tooltip>
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "52px",
                  margin: "5px",
                  cursor: "pointer",
                  color: "#f0f2f7",
                }}
                onClick={() => {
                  if (obj.label === "Zoom To Page") {
                    handleFullPage();
                  }
                  obj.onClick();
                }}
              >
                <PopoverListButtons sx={{ p: 2 }}>
                  {obj.icon}
                </PopoverListButtons>
                <Typography
                  variant="caption"
                  sx={{ mt: 0.5, textAlign: "center", fontSize: "11px" }}
                >
                  {obj.label}
                </Typography>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return <>{renderPopoverContent()}</>;
};

export default CustomViewPopoverContent;
